"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type { BowFlowPoint } from "./BowFlowChart.impl";

export const BowFlowChart = dynamicChart(
  () => import("./BowFlowChart.impl").then((m) => m.BowFlowChart),
  320,
);
